module.exports = __webpack_public_path__ + "img/xxzy.686b9ce6.png";